import axios from 'axios';
import { getSession } from 'next-auth/react';
import Router from 'next/router';

const apiCaller = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_ROOT,
  timeout: 5000,
});

apiCaller.interceptors.request.use(async (request) => {
  const session = await getSession();
  if (session) {
    request.headers.Authorization = `Bearer ${session?.user?.accessToken}`;
  }
  return request;
});

apiCaller.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 404) {
        Router.push('/404');
      }
      if (error.response.status === 403) {
        Router.push('/404');
      }
      if (error.response.status === 401) {
        Router.push('/404');
      }
    } else if (error.request) {
      // The request was made but no response was received
    } else {
      // Something happened in setting up the request that triggered an Error
    }
    throw error;
  },
);

export default apiCaller;
